<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-07 09:19:50
 * @LastEditors: luckymiaow
 * @LastEditTime: 2023-06-29 17:35:46
-->

<script lang="ts" setup>
import { onMounted, ref, unref, useAttrs, useSlots, watch, withDefaults } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import type { Api, ISelectApiProps } from '../types';
import useForm from '../../form/src/useFormConfig';
import SelectBasic from './_SelectBasic.vue';

interface Props extends ISelectApiProps {
  api?: Api;

  params?: object; // 接口参数 此属性改变时会自动重新加载接口数据

  immediate?: boolean; // 是否立即加载数据 默认false
}

const props = withDefaults(defineProps<Props>(), { readOnly: undefined, immediate: false });

const slots = useSlots();

const attrs: ISelectApiProps = useAttrs() as ISelectApiProps;

const { getBindValue } = useForm<ISelectApiProps>({ props, componentName: 'SelectApi', attrs });

const optionsResult = ref<any[]>([]);

const isFirstLoad = ref(true);

const loading = ref(false);

watch(
  () => props.params,
  () => {
    !unref(isFirstLoad) && fetchData();
  }
);

async function fetchData() {
  if (!props?.api || getBindValue.value?.options || 'default' in slots) return;

  try {
    loading.value = true;

    const res = await props.api(unref(props.params));

    const keys = Object.keys(res);

    if (keys.includes('limit') && keys.includes('offset')) {
      throw new Error('分页接口请使用分页选择器！或者传入params{limit: 10, offset: 0}！');
    }

    optionsResult.value = res;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
}

async function dropdownVisibleChange() {
  if (unref(isFirstLoad)) {
    await fetchData();
    isFirstLoad.value = false;
  }
}

onMounted(() => {
  if (props.immediate) {
    dropdownVisibleChange();
  }
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <SelectBasic v-bind="getBindValue" :options="optionsResult" @dropdownVisibleChange="dropdownVisibleChange">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
    <template v-if="loading" #suffixIcon>
      <LoadingOutlined spin />
    </template>
  </SelectBasic>
</template>
